import { Injectable } from '@angular/core';
import { ScenarioService } from './scenario.service';
import { PublishedService } from './published.service';
import { ScenarioVersionService } from './scenario-version.service';
import { MediaService } from './media.service';
import { SnippetService } from './snippet.service';
import { PlayerSessionService } from './player-session.service';
import { AnalyticsService } from './analytics.service';
import { LibraryService } from './library.service';

@Injectable({
  providedIn: 'root',
})
export class CacheManagerService {
  constructor(
    private scenarioService: ScenarioService,
    private publishedService: PublishedService,
    private scenarioVersionsService: ScenarioVersionService,
    private mediaService: MediaService,
    private snippetService: SnippetService,
    private playerSessionService: PlayerSessionService,
    private libraryService: LibraryService,
  ) {}

  clearAllCache() {
    this.scenarioService.clearCache();
    this.publishedService.clearCache();
    this.scenarioVersionsService.clearCache();
    this.mediaService.clearCache();
    this.snippetService.clearCache();
    this.playerSessionService.clearCache();
    this.libraryService.clearCache();
  }
}
